import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll the window to the top whenever the route pathname changes.
 * Drop-in helper for browsers that restore prior scroll positions
 * (which makes navigating to a new page land mid-content instead of at the top).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
